import { Badge } from '@mantine/core';
import { useLanguage } from '../../i18n/LanguageProvider';

export const BetaBadge = () => {
  const { messages } = useLanguage();

  return (
    <Badge
      size="xs"
      variant="filled"
      color="yellow"
      style={{
        height: 20,
        fontSize: 10,
        fontWeight: 600,
      }}
    >
      {messages.common.beta}
    </Badge>
  );
};
